module.exports = __webpack_public_path__ + "img/img28.3a27f0b0.svg";